import { useHandleClick } from './use-handle-click';
import { useHandleContextMenu } from './use-handle-context-menu';
import { useHandleMouseDown } from './use-handle-mousedown';

/** DND相关的全局拖拽 */
export const useMouseEvent = (readonly?: boolean) => {
  useHandleClick();
  useHandleContextMenu(readonly);
  useHandleMouseDown();
};
